/******************
* Main config
*******************/

if (typeof FN == 'undefined') FN = {};


FN.config = {
  urls: {
    base: false,
    apiBase: false,
    newsletter: false,
    apiContactSubscribe: 'contacts/subscribe',
    apiContactUpdate: 'contacts/update',
    licensingBase: false
  },
  analytics: {
    siteID: 'learn-website',
    addPlatformToEventLabel: false
  },
  responsiveBreakpoints: [
    // NOTE: values here must be the same as in _variables.scss!!
    { 'media': 'xl', 'width': '1400px' },
    { 'media': 'l', 'width': '1080px' },
    { 'media': 'm', 'width': '760px' },
    { 'media': 's', 'width': '420px' },
    { 'media': 'xs', 'width': '1px' }
  ]
};


FN.config.setEnvironmentUrls = function (type) {
  var urls = { 'base': false, 'apiBase': false };
  var host = window.location.host;

  if (host.indexOf('website-learn') === 0) {
    // development
    urls.base = '/';
    urls.apiBase = 'http://website-api.test/';
    urls.newsletter = 'http://website-api.test/contacts/subscribe';
    urls.licensingBase = 'https://staging.account.git-tower.com/api/';
  } else if (host.indexOf('staging.git-tower.com') === 0) {
    // staging
    urls.base = '/';
    urls.apiBase = 'https://staging.git-tower.com/api/';
    urls.newsletter = 'https://staging.git-tower.com/api/contacts/subscribe';
    urls.licensingBase = 'https://staging.account.git-tower.com/api/';
  } else {
    // production
    urls.base = '/learn/';
    urls.apiBase = 'https://www.git-tower.com/api/';
    urls.newsletter = 'https://www.git-tower.com/api/contacts/subscribe';
    urls.licensingBase = 'https://account.git-tower.com/api/';
  }

  FN.config.urls.base = urls.base;
  FN.config.urls.apiBase = urls.apiBase;
  FN.config.urls.newsletter = urls.newsletter;
  FN.config.urls.licensingBase = urls.licensingBase;
}
FN.config.setEnvironmentUrls();

FN.config.analyticsEvents = [
  /* Newsletter Subscription */
  {
    'config': { 'selector': '#after-download-modal .newsletter-form.analytics--submit', 'triggerOnlyOnce': true },
    'event': { 'eventCategory': 'newsletter', 'eventAction': 'signup', 'eventLabelSuffix': 'trial-download' }
  },
  {
    'config': { 'selector': '#trial-via-email .newsletter-form.analytics--submit', 'triggerOnlyOnce': true },
    'event': { 'eventCategory': 'newsletter', 'eventAction': 'signup', 'eventLabelSuffix': 'trial-via-email' }
  },
  /* Trial Download Buttons */
  {
    'config': { 'selector': '.nav-top-download .visible-on--mac .button--start-trial.analytics--click' },
    'event': { 'eventCategory': 'sales', 'eventAction': 'trial-download-mac', 'eventLabelSuffix': 'top-navi' }
  },
  {
    'config': { 'selector': '.nav-top-download .visible-on--windows .button--start-trial.analytics--click' },
    'event': { 'eventCategory': 'sales', 'eventAction': 'trial-download-windows', 'eventLabelSuffix': 'top-navi' }
  },
  /* Twitter */
  {
    'config': { 'selector': '#after-subscribe-modal .button--twitter.analytics--click' },
    'event': { 'eventCategory': 'social', 'eventAction': 'share', 'eventLabelSuffix': 'twitter' }
  }
];

$(document).ready(function () {
  FN.analytics.addConfiguredEvents(FN.config.analyticsEvents);

  /*********** prefill "signup[OS]" value in newsletter forms */
  if ($('input[name="signup[OS]"]').length > 0) {
    $('input[name="signup[OS]"]').val(FN.helpers.platform());
  }


  /*********** newsletter subscription */
  $('.' + FN.newsletterConfig.selectors.formClass).each(function (index, element) {
    FN.newsletterConfig.instances.push(new FN.newsletter(element));
  });

});
